<template>
  <Layout>
    <DataBox :loading="loading" :error="error">
      <PageTitle />

      <CardsWrapper class="cards" />

      <div class="row">
        <div :class="canReadFinances ? 'col-xs-12 col-sm-12 col-md-4 col-lg-4' : 'line'">
          <div class="line_item">
            <!-- <CreateTransaction /> -->
            <Poll />
          </div>

          <!-- <div class="line_item">
            <TariffSettings />
          </div> -->

          <div class="line_item">
            <ApiLimits />
          </div>
        </div>

        <div v-if="canReadFinances" class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <Report v-if="$currentApp" />
        </div>
      </div>

      <div class="row">
        <div v-if="canReadFinances" class="col-xs-12">
          <TransactionsTable />
        </div>
      </div>
    </DataBox>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
// import TariffSettings from './TariffSettings.vue'
import Report from './report/Report.vue'
// import CreateTransaction from './CreateTransaction.vue'
import CardsWrapper from './cards/index.vue'
import DataBox from '@/components/DataBox.vue'

import { ApplicationsService } from '@/services/applications.service'
import { redirectIfDenied } from '@/services/ability.service'

import currentApplicationMixin from './mixins/currentApplicationMixin'
import { mapGetters } from 'vuex'

export default {
  components: {
    Layout,
    PageTitle: () => import('./PageTitle.vue'),
    CardsWrapper,
    // TariffSettings,
    TransactionsTable: () => import('./transactionTable/TransactionsTable.vue'),
    ApiLimits: () => import('./ApiLimits.vue'),
    // CreateTransaction,
    Poll: () => import('./Poll.vue'),
    Report,
    DataBox,
  },
  mixins: [currentApplicationMixin],
  data() {
    return {
      loading: false,
      error: false,
    }
  },
  computed: {
    ...mapGetters({
      abilities: 'user/definedAbilities',
    }),
    canReadFinances() {
      return this.abilities.can('read', 'finances')
    },
  },
  mounted() {
    this.getApplicationById()
  },
  destroyed() {
    this.$store.commit('application/CLEAR_CURRENT_APPLICATION')
  },
  methods: {
    /**
     * Send request to backend for get one Application by id.
     * Then run mutation `SET_CURRENT_APPLICATION` in vuex.
     *
     * @returns {Object} data Response wrapper. Contains data of `Application`.
     * */
    async getApplicationById() {
      this.loading = true
      try {
        const id = this.$route.params.id

        const { data } = await ApplicationsService.getById({ id })

        this.$store.commit('application/SET_CURRENT_APPLICATION', { ...data })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message

        redirectIfDenied.call(this, error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.line {
  width: 100%;
  padding: rem(20px);

  @include media_custom(656px) {
    padding: 0;

    .line_item {
      width: 50%;
      padding: 1.25rem;
    }

    @include createFlex(flexbox, nowrap, row, flex-start, stretch, stretch);
  }

  @include media_custom(1040px) {
    .line_item {
      width: 33%;
    }
  }
}
</style>
